import { Service } from '@tino-frontend/adapters'
import {
  ConfirmAcknowledgePayload,
  PendingTermsResponse,
  PolicyResponse,
} from '@types'
export class PolicyService {
  constructor(private readonly http: Service) {
    this.http = http
  }

  privacyPolicy(): Promise<any> {
    return this.http.get(`/privacy-policy`)
  }

  getLegalPersonTerms(legalPersonId: string): Promise<PolicyResponse> {
    return this.http.get(`/onboarding/legal-person/${legalPersonId}/terms`)
  }

  getSignUpTerms(): Promise<PendingTermsResponse> {
    return this.http.get('/terms/sign-up')
  }

  acceptLegalPersonTerms(legalPersonId: string): Promise<PolicyResponse> {
    return this.http.post(`/onboarding/legal-person/${legalPersonId}/terms`)
  }

  getPendingTerms(): Promise<PendingTermsResponse> {
    return this.http.get(`/me/pending-terms`)
  }

  useTerms(): Promise<PolicyResponse> {
    return this.http.get(`/use-terms`)
  }

  acceptTerms(termId: string): Promise<void> {
    return this.http.post(`/me/pending-terms/${termId}`)
  }

  agreement(): Promise<any> {
    return this.http.get(`/agreement`)
  }

  salespersonUseTerms(): Promise<PolicyResponse> {
    return this.http.get(`/salesperson-use-terms`)
  }

  confirmAcknowledge({
    merchantCompanyId,
    supplierId,
    has_acknowledge,
  }: ConfirmAcknowledgePayload) {
    return this.http.post(`/merchants/${merchantCompanyId}/acknowledge-terms`, {
      has_acknowledge,
      supplier_id: supplierId,
    })
  }
}
